import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './request/api.js'
import 'amfe-flexible/index.js'
import './static/css/reset.css'
import 'mint-ui/lib/style.css'
import {
  Toast
} from 'mint-ui';
// import { Picker } from 'vant';
import Vant from 'vant'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './static/css/my-mint.css'
import 'vant/lib/index.css';
// import VueWechatTitle from "vue-wechat-title";
Vue.use(Vant)
Vue.use(ElementUI)
Vue.prototype.$Toast = Toast;
Vue.prototype.$api = api; // 将api挂载到vue的原型上

// Vue.use(VueWechatTitle);
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'

// Vue.use(VideoPlayer)

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video  // 在vue的原生里添加了Video这个标签，增强了vue的功能性


Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

/* 路由发生变化修改页面title */
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })
Vue.directive('title', {//单个修改标题
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')